import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS}
const InitialState = {
  data: [],
  errors: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      //
      // remove toggled off data
      const _data = (action.payload.data || []).map(d => {
        const group_view = d.group_view
        group_view.groups = group_view.groups.filter(f => f.active)
        group_view.actions = group_view.actions.filter(f => f.active)
        return {group_view}
      })

      return {
        ...state,
        isLoading: false,
        errors: null,
        data: _data || [],
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}

const useGetCalendarViewsReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useGetCalendarViewsReducer
export {ActionTypes, InitialState, Reducer}
